export default __webpack_public_path__ + "static/media/foto-documento.eda29a86.jpg";